import { 
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase';

// ==================== KOLEKSİYON ====================
const notificationsCollection = collection(db, 'Notifications');

// ==================== BİLDİRİM SİSTEMİ ====================

/**
 * Bildirim gönder
 */
export const sendNotification = async (type, title, message, userId = null) => {
  try {
    const notification = {
      type, // 'order', 'stock', 'campaign', 'system', 'cancellation', 'return'
      title,
      message,
      userId,
      isRead: false,
      createdAt: serverTimestamp()
    };
    
    const docRef = await addDoc(notificationsCollection, notification);
    
    return { success: true, notificationId: docRef.id };
  } catch (error) {
    console.error('Bildirim gönderilemedi:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Bildirimleri getir
 */
export const getNotifications = async (userId = null, unreadOnly = false) => {
  try {
    let q = query(notificationsCollection, orderBy('createdAt', 'desc'), limit(50));
    
    if (userId) {
      q = query(q, where('userId', 'in', [userId, null]));
    }
    
    if (unreadOnly) {
      q = query(q, where('isRead', '==', false));
    }
    
    const snapshot = await getDocs(q);
    const notifications = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate?.() || data.createdAt
      };
    });
    
    return { success: true, notifications };
  } catch (error) {
    console.error('Bildirimler alınamadı:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Bildirimi okundu olarak işaretle
 */
export const markNotificationAsRead = async (notificationId) => {
  try {
    const notificationRef = doc(db, 'Notifications', notificationId);
    await updateDoc(notificationRef, {
      isRead: true,
      readAt: serverTimestamp()
    });
    
    return { success: true };
  } catch (error) {
    console.error('Bildirim işaretlenemedi:', error);
    return { success: false, error: error.message };
  }
};

export default {
  sendNotification,
  getNotifications,
  markNotificationAsRead
};
